type TPaymentMethodTitle = {
  title?: string;
};

const PaymentMethodTitle = ({ title }: TPaymentMethodTitle) => {
  return (
    <div className="co-flex co-flex-col co-w-full co-gap-16px lg:co-flex-row lg:co-justify-between">
      <p
        id={title}
        className="co-font-semibold co-text-h2 lg:co-text-[16px] co-leading-[30px]"
        tabIndex={0}
      >
        {title}
      </p>
    </div>
  );
};

export default PaymentMethodTitle;
